import { useMemo } from 'react';
import { useGameStore } from '../GameStoreContext.ts';
import { PlayerValidator } from '@colonist/game-mechanic-validators';
export const usePlayerValidators = ()=>{
    const playerStates = useGameStore((state)=>state.gameState.playerStates);
    const getUserState = useGameStore((state)=>state.gameUserStates.getUserState);
    const currentUserId = useGameStore((state)=>state.gameClientConfig.currentUserId);
    return useMemo(()=>{
        const playerValidatorsMap = new Map();
        for (const [colorStr, playerState] of Object.entries(playerStates)){
            const color = parseInt(colorStr, 10);
            const userState = getUserState(color);
            const playerValidator = new PlayerValidator(playerState, userState, currentUserId);
            playerValidatorsMap.set(color, playerValidator);
        }
        const getPlayerValidator = (color)=>{
            const playerValidator = playerValidatorsMap.get(color);
            if (!playerValidator) throw new Error(`Player validator not found for color ${color}`);
            return playerValidator;
        };
        return {
            playerValidators: Array.from(playerValidatorsMap.values()),
            getPlayerValidator: getPlayerValidator
        };
    }, [
        playerStates,
        getUserState,
        currentUserId
    ]);
};
